// extracted by mini-css-extract-plugin
export default {"typeContainer":"TypesSection-module__typeContainer--YI5mY"};